<template>
  <div class="memorabilia">
    <img
      v-if="!isIndex"
      class="study-floor-img"
      src="@/assets/memorabilia_bg.jpg"
      alt="背景图"
    />
    <div class="memorabilia-inner" v-if="!isIndex">
      <div class="memorabilia-title">{{ lan === 0 ? "塱头乡村振兴项目大事记" : "Langtou Rural Revitalization Project Milestones" }}</div>

      <!-- 左右布局容器 -->
      <div class="tab-container">
        <!-- 左侧Tab栏 -->
        <div class="tab-bar">
          <div
            v-for="(tab, index) in tabs"
            :key="tab.year"
            class="tab-item"
            :class="{ active: activeTab === index }"
            @click="switchTab(index)"
          >
            {{ tab.year == "2020" ? (lan === 0 ? "项目缘起" : "Project Origins") : tab.year + (lan === 0 ? "年" : "") }}
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="content-wrapper">
          <div
            v-for="(tab, index) in tabs"
            :key="tab.year"
            class="content-item"
            :class="{ active: activeTab === index }"
          >
            <div class="wap-scroll-content">
              <div
                v-for="(event, i) in tab.data"
                :key="i"
                class="timeline-item"
              >
                <div class="timeline-dot"></div>
                <div class="timeline-content">
                  <div class="event-date">{{ event.dateEnd === '项目缘起' ? (lan === 0 ? '项目缘起' : 'Project Origins') : event.dateEnd }}</div>
                  <div
                    class="event-content"
                    v-html="lan === 0 ? event.contentCn : event.contentEn"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="mobile-wrapper">
        <div class="wap-act-tab" ref="tabBar">
          <div
            class="wap-tab"
            v-for="(tab, index) in tabs"
            :key="tab.year"
            @click="actTap(tab)"
            :class="{ active: activeTab === index }"
          >
            {{ tab.year == "2020" ? (lan === 0 ? "2021年之前" : "Project Origins") : tab.year + (lan === 0 ? "年" : "") }}
          </div>
        </div>
        <!-- Mobile content: Horizontal slider for tab contents -->
        <div
          class="content-slider"
          ref="contentSlider"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
        >
          <div
            class="slider-inner"
            :style="{ transform: `translateX(-${activeTab * 100}%)` }"
          >
            <div v-for="tab in tabs" :key="tab.year" class="slide-item">
              <div class="wap-scroll-content" ref="scrollContents">
                <div
                  v-for="(event, i) in tab.data"
                  :key="i"
                  class="timeline-item"
                >
                  <div class="timeline-dot"></div>
                  <div class="timeline-content">
                    <div class="event-date">{{ event.dateEnd === '项目缘起' ? (lan === 0 ? '项目缘起' : 'Project Origins') : event.dateEnd }}</div>
                    <div
                    class="event-content"
                    v-html="lan === 0 ? event.contentCn : event.contentEn"
                  ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Memorabilia",
  data() {
    return {
      isIndex: false,
      activeTab: 0,
      lan: this.$store.state.isEn, // 同步全局语言状态
      tabs: [],
      touchStartX: 0,
      touchDeltaX: 0,
      sliderWidth: 0,
      resizeTimer: null // 添加resize防抖定时器
    };
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  watch: {
    // 监听全局语言变化
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.init();
    // 添加窗口大小变化监听器
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.handleResize);
    // 清除可能存在的定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    handleMediaQueryChange(event) {
      let screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
        this.screenWidth = screenWidth;
      }
    },
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    async init() {
      const currentYear = new Date().getFullYear();
      await this.$api.post(
        "/events/list",
        { year: currentYear.toString() },
        (r) => {
          const { data, code } = r;
          if (code === 0) {
            this.tabs = data.map((t) => ({
              year: t.year,
              data: (t.data || []).map(event => ({
                ...event,
                contentEn: this.replaceChineseQuotes(event.contentEn)
              })),
              loaded: t.data?.length > 0,
              loading: false,
            }));
            // 自动选择第一个有数据的年份
            const validIndex = this.tabs.findIndex((t) => t.loaded);
            this.activeTab = validIndex > -1 ? validIndex : 0;

            // 如果初始选中项未加载则发起请求
            if (!this.tabs[this.activeTab].loaded) {
              this.loadYearData(this.activeTab);
            }
            
            // 更新富文本字体大小
            this.$nextTick(() => {
              this.updateRichTextFont();
            });
          }
        }
      );
    },

    async loadYearData(targetIndex) {
      const tab = this.tabs[targetIndex];
      if (tab.loaded || tab.loading) return;

      try {
        this.$set(this.tabs, targetIndex, { ...tab, loading: true });
        this.$api.post("/events/list", { year: tab.year }, (r) => {
          const { data, code } = r;
          if (code === 0) {
            const targetYear = data.find((d) => d.year === tab.year);
            this.$set(this.tabs, targetIndex, {
              ...tab,
              data: (targetYear?.data || []).map(event => ({
                ...event,
                contentEn: this.replaceChineseQuotes(event.contentEn)
              })),
              loaded: true,
              loading: false,
            });
            
            // 更新富文本字体大小
            this.$nextTick(() => {
              this.updateRichTextFont();
            });
          }
        });
      } catch (error) {
        this.$set(this.tabs, targetIndex, { ...tab, loading: false });
      }
    },

    switchTab(index) {
      if (this.activeTab === index) return;

      this.activeTab = index;

      // 检查是否需要加载数据
      if (!this.tabs[index].loaded) {
        this.loadYearData(index);
      } else {
        // 更新富文本字体大小
        this.$nextTick(() => {
          this.updateRichTextFont();
        });
      }
    },
    
    // 更新富文本内容的字体大小
    updateRichTextFont() {
      // 获取屏幕宽度
      const screenWidth = window.innerWidth || document.documentElement.clientWidth;
      
      // 根据屏幕宽度设置字体大小
      let baseFontSize, baseLineHeight;
      if (screenWidth > 1440) {
        baseFontSize = '20px';
        baseLineHeight = '32px';
      } else if (screenWidth > 960) {
        baseFontSize = '16px';
        baseLineHeight = '30px';
      } else {
        baseFontSize = '14px';
        baseLineHeight = '28px';
      }
      
      // 查找所有的富文本容器
      const richTextElements = document.querySelectorAll('.event-content');
      
      // 为每个富文本容器设置字体样式
      richTextElements.forEach(element => {
        // 设置基础字体样式
        element.style.fontSize = baseFontSize;
        element.style.lineHeight = baseLineHeight;
        element.style.fontFamily = 'SourceHanSansCN-Regular';
        
        // 为子元素设置样式
        const children = element.querySelectorAll('*');
        children.forEach(child => {
          // 强制设置字体大小和行高，避免被内联样式覆盖
          child.style.fontSize = 'inherit';
          child.style.lineHeight = 'inherit';
          
          // 特殊处理标题标签
          if (child.tagName === 'H1' || child.tagName === 'H2') {
            child.style.fontSize = baseFontSize === '20px' ? '24px' : 
                                 baseFontSize === '18px' ? '22px' : '20px';
            child.style.fontWeight = 'bold';
          } else if (child.tagName === 'H3' || child.tagName === 'H4' || 
                     child.tagName === 'H5' || child.tagName === 'H6') {
            child.style.fontSize = baseFontSize === '20px' ? '22px' : 
                                 baseFontSize === '18px' ? '20px' : '18px';
            child.style.fontWeight = 'bold';
          }
        });
      });
    },
    
    // 监听窗口大小变化
    handleResize() {
      // 防抖处理
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        this.updateRichTextFont();
      }, 100);
    },
    actTap(tab) {
      const index = this.tabs.findIndex((t) => t.year === tab.year);
      if (index !== -1 && this.activeTab !== index) {
        this.switchTab(index);
        this.scrollToTop(); // Scroll to top on tab switch
      }
    },
    scrollToTop() {
      if (
        this.$refs.scrollContents &&
        this.$refs.scrollContents[this.activeTab]
      ) {
        this.$refs.scrollContents[this.activeTab].scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.sliderWidth = this.$refs.contentSlider.offsetWidth;
    },
    onTouchMove(e) {
      const touchX = e.touches[0].clientX;
      this.touchDeltaX = touchX - this.touchStartX;
    },
    onTouchEnd() {
      if (Math.abs(this.touchDeltaX) > this.sliderWidth / 3) {
        // Threshold for swipe
        let newIndex = this.activeTab;
        if (this.touchDeltaX > 0) {
          newIndex = Math.max(0, this.activeTab - 1); // Swipe right: prev tab
        } else {
          newIndex = Math.min(this.tabs.length - 1, this.activeTab + 1); // Swipe left: next tab
        }
        if (newIndex !== this.activeTab) {
          this.switchTab(newIndex);
          this.scrollToTop(); // Scroll to top on swipe switch
        }
      }
      this.touchDeltaX = 0; // Reset
    },
  },
};
</script>

<style scoped>
/* 原有样式保持不变 */
.memorabilia {
  position: relative;
  margin-top: 94px;
  min-height: 100%;
  background-color: #e4e4e4;
}

.study-floor-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.memorabilia-inner {
  position: relative;
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 5px 0;
}

.memorabilia-title {
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  margin: 50px 0 30px;
}

.tab-container {
  display: flex;
  min-height: 770px;
}

.tab-bar {
  flex: 0 0 300px;
  background: #fff;
  padding: 45px 0 0;
}

.tab-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  font-family: SourceHanSansCN-Medium;
  font-size: 26px;
  color: #585c64;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center;
}

.tab-item:hover {
  font-family: SourceHanSansCN-Heavy;
  font-size: 36px;
  color: #ca9d76;
  letter-spacing: 0;
  font-weight: 900;
}

.tab-item.active {
  font-family: SourceHanSansCN-Heavy;
  font-size: 36px;
  color: #ca9d76;
  letter-spacing: 0;
  font-weight: 900;
}

.content-wrapper {
  flex: 1;
  background: #fff;
  padding: 78px 20px 20px;
}

.content-item {
  display: none;
}

.content-item.active {
  display: block;
}

.wap-scroll-content {
  position: relative;
  height: 660px;
  overflow-y: auto;
  padding: 0 15px;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #D8D8D8 transparent; /* Firefox */
}
/* Chrome/Safari 滚动条样式 */
.wap-scroll-content::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}
.wap-scroll-content::-webkit-scrollbar-track {
  background-color: rgba(245, 245, 245, 0.8);
  border-radius: 4px;
  margin: 10px 0;
}
.wap-scroll-content::-webkit-scrollbar-thumb {
  background-color: #D8D8D8;
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: content-box;
}

.wap-scroll-content::-webkit-scrollbar-thumb:hover {
  background-color: #ca9d76;
}
.wap-scroll-content::before {
  content: "";
  position: absolute;
  left: 15;
  top: 15px; /* 控制边框起始位置 */
  bottom: 0;
  width: 2px;
  background: #eee;
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  padding-bottom: 30px;
}
/* 新增伪元素实现自定义左边框 */
.timeline-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 15px; /* 控制边框起始位置 */
  bottom: 0;
  width: 2px;
  background: #eee;
}

.timeline-dot {
  position: absolute;
  left: -4px;
  top: 12px;
  width: 10px;
  height: 10px;
  background: #ca9d76;
  border-radius: 50%;
}

.event-date {
  display: flex;
  font-family: SourceHanSansCN-Bold;
  font-size: 22px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-bottom: 8px;
}

/* 原始样式 */
.event-content {
  font-family: SourceHanSansCN-Regular;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  font-size: 20px !important;
  line-height: 32px !important;
  font-weight: 400;
}

/* 深度选择器处理内联样式 */
.event-content ::v-deep * {
  font-size: inherit !important;
  line-height: inherit !important;
}

/* 针对特定标签的样式 */
.event-content p,
.event-content span,
.event-content strong,
.event-content em {
  font-size: inherit !important;
  line-height: inherit !important;
}

.event-content ::v-deep p {
  padding: 0 0 10px;
  margin: 0;
}
@media (max-width: 1440px) {
  .memorabilia-inner {
    position: relative;
    width: 90%;
  }
  .tab-bar {
    flex: 0 0 23%;
  }
  .tab-item {
    padding: 15px 20px;
    cursor: pointer;
    transition: all 0.3s;
    font-family: SourceHanSansCN-Medium;
    font-size: 22px;
    color: #585c64;
    letter-spacing: 0;
    font-weight: 500;
    text-align: center;
  }

  .tab-item:hover {
    font-family: SourceHanSansCN-Heavy;
    font-size: 30px;
    color: #ca9d76;
    letter-spacing: 0;
    font-weight: 900;
  }
  .event-date {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .event-content {
    font-family: SourceHanSansCN-Regular;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-size: 18px !important;
    line-height: 32px !important;
    font-weight: 400;
  }
}
@media (max-width: 960px) {
  .memorabilia {
    background-color: #fff;
    min-height: 100%;
  }
  .wap-tab {
    border: 2px solid rgba(102, 102, 102, 1);
    border-radius: 4px;
    width: 130px;
    height: 48px;
    line-height: 45px;
    text-align: center;
    color: #000;
    font-size: 16px;
    flex: 0 0 auto;
    margin: 0 10px;
  }
  .actSlider-component {
    margin-bottom: 40px;
  }
  .actTap {
    background-color: #000;
    color: #fff;
  }
  .active {
    background-color: #000;
    color: #fff;
  }

  .content-wrapper {
    padding: 20px;
  }
  .mobile-wrapper {
    position: relative;
  }
  .wap-act-tab {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    white-space: nowrap;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
    padding: 10px 0;
    scrollbar-width: none;
  }
  .wap-act-tab::-webkit-scrollbar {
    display: none;
  }
  .content-slider {
    margin-top: 28px;
    background-color: #fff;
    overflow: hidden;
  }
  .slider-inner {
    display: flex;
    width: calc(100% * var(--num-tabs));
    transition: transform 0.3s ease;
  }
  :root {
    --num-tabs: 1;
  }
  .slide-item {
    flex: 0 0 100%;
    width: 100%;
    padding: 20px;
  }
  .scroll-content {
    height: auto;
    overflow-y: auto;
  }
  .event-date {
    font-family: SourceHanSansCN-Bold;
    font-size: 18px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .event-content {
    font-family: SourceHanSansCN-Regular;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-size: 16px !important;
    line-height: 28px !important;
    font-weight: 400;
  }
  .timeline-dot {
    position: absolute;
    left: -4px;
    top: 6px;
    width: 10px;
    height: 10px;
    background: #ca9d76;
    border-radius: 50%;
  }
  .timeline-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px; /* 控制边框起始位置 */
    bottom: 0;
    width: 2px;
    background: #eee;
  }
  .wap-scroll-content::before {
    content: "";
    position: absolute;
    left: 15;
    top: 15px; /* 控制边框起始位置 */
    bottom: -100px;
    width: 2px;
    background: #eee;
  }
}
</style>
